import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { hookUtils } from '@indico-data/utils';
import { Button } from 'Permafrost/index';
import { Icon } from 'Permafrost/index';
import { StyledFilter } from './Filter.styles';
import { isEqual } from 'lodash';
export const Filter = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { filter, onFilter, optionsList, isMulti = false, placement = 'right' } = props;
    const menuEl = useRef();
    const hasFilter = !!filter.length;
    const handleToggleMultiFilter = (option) => {
        if (filter.some((filterOption) => isEqual(filterOption.value, option.value))) {
            onFilter(filter.filter((filterOption) => !isEqual(filterOption.value, option.value)));
        }
        else {
            onFilter([...filter, option]);
        }
    };
    const handleToggleSingleFilter = (option) => {
        isEqual(filter[0], option) && hasFilter ? onFilter([]) : onFilter([option]);
    };
    const handleOptionClick = (option) => {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    hookUtils.useClickOutside(menuEl, () => {
        setIsOpen(false);
    });
    return (React.createElement(StyledFilter, { ref: menuEl, "$placement": placement, className: "filter" },
        React.createElement(Button, { variant: "outline", className: classNames('filter__toggle', 'square', {
                'filters-on': hasFilter,
            }), "data-testid": "button-filter-toggle", onClick: () => {
                setIsOpen(!isOpen);
            } },
            props.label ? React.createElement("span", { className: "filter-label" }, props.label) : null,
            React.createElement(Icon, { name: "filter-outline" }),
            hasFilter ? React.createElement("span", { className: "swatch-circle" }) : []),
        React.createElement("div", { "data-testid": "div-filter-options-container", className: classNames('filter__container', {
                visible: isOpen,
            }) },
            hasFilter ? (React.createElement("p", { className: "filter__clear-filter", onClick: () => {
                    onFilter([]);
                } }, "Clear Filter")) : ([]),
            React.createElement("div", { className: "filter__options" },
                React.createElement("h4", { className: "filter__title" }, "FILTER ON"),
                React.createElement("ul", null, optionsList.map((filterOption) => {
                    const { text, value, iconName } = filterOption;
                    const selected = filter.some((item) => item.value === value);
                    return (React.createElement("li", { key: `LabelFilter-${value}`, "data-testid": `li--filter-list-${value}`, className: classNames('filter__option', {
                            selected,
                        }), onClick: () => {
                            handleOptionClick(filterOption);
                        } },
                        selected ? (React.createElement(Icon, { name: "check", className: "filter__check", "data-testid": `li--filter-list-icon-selected-indicator-for-${value}` })) : ([]),
                        ' ',
                        text,
                        iconName ? (React.createElement(Icon, { name: iconName, className: "filter__icon", "data-testid": `li--filter-list-icon-for-${value}` })) : ([])));
                }))))));
};
//# sourceMappingURL=Filter.js.map